import { intro } from './intro';
import { equipment } from './equipment';
import { settings } from './settings';
import { ingredients } from './ingredients';
import { instructions } from './instructions';
import { notes } from './notes';

export const recipe = {
    intro: intro,
    equipment: equipment,
    settings: settings,
    ingredients: ingredients,
    instructions: instructions,
    notes: notes
}